export { TypePrimaryState } from "./TypePrimaryState";
